export default __webpack_public_path__ + "static/Plate_2x2_Black_RGB-15f5079e8136999aa673471c9f986883.svg";